<script lang="ts" setup>
import { faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { TrackTarget } from '@/api';
import { useTracking } from '@/utilities/tracking.ts';

const props = defineProps<{
  phoneNumber?: string | null;
  name?: string | null;
  target: TrackTarget;
  targetId: number;
}>();

const { trackAction } = useTracking();
const i18n = useI18n();
const { t } = i18n;

const showPhoneNumber = ref(false);

const formatted = computed(() => {
  const value = props.phoneNumber;
  const locale = i18n.locale.value;
  return value?.formatPhoneNumber(locale);
});

function onClick() {
  void trackAction(props.target, props.targetId, 'phoneClick');
  if (props.phoneNumber) {
    showPhoneNumber.value = true;
    window.location.href = `tel:${props.phoneNumber}`;
  }
}
</script>

<template>
  <a v-if="phoneNumber && phoneNumber.length > 0" :href="`tel:${phoneNumber}`" class="no-print hover:bg-ph-green-600 bg-ph-green-700 inline-block cursor-pointer rounded-lg px-4 py-2 text-white" @click.prevent="onClick">
    <FontAwesomeIcon :icon="faPhone" class="text-ph-green-200 mr-2" />
    <span>{{ showPhoneNumber ? formatted : name ? t('components.phone-button.phone-with-name', { name: name }) : t('components.phone-button.phone') }}</span>
  </a>
</template>

<style lang="css" scoped></style>
